// extracted by mini-css-extract-plugin
module.exports = {"socialAuth":"SocialAuthUi__socialAuth__1Zntz","buttonWrapper":"SocialAuthUi__buttonWrapper__3Mwrb"};